import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
//import { useNavigate } from "react-router-dom";
import { useOktaAuth } from "@okta/okta-react";
import logo from "../../assets/cfa-logo.svg";
import { Typography, Button } from "../../ots-components";
// import hamburger from "../../assets/hamburger-icon.svg";

import "./NavBar.scss";

/**
 * NavBar – a navbar, with app name, logo, sign in state, and toggle menu
 * uses useOktaAuth for authState
 * set app name in .env file
 *
 * @param toggleMenu callback to run when sidebar is clicked out of or is open/closed, should toggle isOpen
 */

export interface NavBarProps {
  toggleMenu?: () => void;
}

function NavBar(): React.JSX.Element {
  //const navigate = useNavigate();
  const { authState, oktaAuth } = useOktaAuth();
  const [name, setName] = useState("");
  const loggedIn = authState?.isAuthenticated;

  useEffect(() => {
    if (loggedIn) {
      oktaAuth.getUser().then((user) => {
        if (user.name) {
          setName(user.name);
        }
      });
    }
  }, [loggedIn, name, oktaAuth]);

  const signIn = async () => {
    oktaAuth.signInWithRedirect({ originalUri: "/" });
  };

  return (
    <Grid container className="topNavBar">
      <Grid size={1} className="divider">
        <img src={logo} alt="Home" className="companyLogo" />
      </Grid>
      <Grid size={1} />
      <Grid size={8}>
        <Typography as="h2" variant="h2" className="topNavBarAppName">
          Franchise Availability Report
        </Typography>
      </Grid>
      <Grid size={2} className="topNavBarEnd">
        {!loggedIn && (
          <Button className="signIn linkButton" onClick={signIn}>
            Sign In
          </Button>
        )}
        {loggedIn && name && (
          <span className="userBox">
            <p>Hello {name}</p>
            <Button
              className="signOut linkButton"
              onClick={async () => {
                oktaAuth.signOut();
              }}
            >
              ( Sign Out )
            </Button>
          </span>
        )}
        {/* <input
          type="image"
          src={hamburger}
          alt="menu"
          className="hamburger"
          onClick={toggleMenu}
          onKeyDown={toggleMenu}
        /> */}
      </Grid>
    </Grid>
  );
}

export default NavBar;
